// extracted by mini-css-extract-plugin
export default {"title":"whcrWBiVe2","button":"Wb5FZLSIKe"};